module.exports = __webpack_public_path__ + "media/images/icons/icon-card-1e32fa3bd1d8afcbd1f170f1ad9873f0.svg";